import { REST_API } from "../env/config";

export interface Translation {
  id: number;
  code: string;
  name: string;
  language: string;
}

interface StartupData {
  books: string[];
  translations: Translation[];
}

export async function retrieveTranslations(): Promise<Translation[]> {
  const url = REST_API + "/translations";
  const response = await fetch(url);
  return await response.json();
}

export async function retrieveBooks(): Promise<string[]> {
  const url = REST_API + "/books";
  const response = await fetch(url);
  return await response.json();
}

export async function retrieveStartupData(): Promise<StartupData> {
  const [books, translations] = await Promise.all([retrieveBooks(), retrieveTranslations()]);

  return {
    translations,
    books,
  };
}

let startupDataSingleton: StartupData | null = null;
let startupDataPromise: Promise<StartupData> | null = null;

export async function getStartupData(): Promise<StartupData> {
  if (startupDataSingleton) {
    return startupDataSingleton;
  }
  if (startupDataPromise) {
    return startupDataPromise;
  }
  startupDataPromise = retrieveStartupData()
    .then((data) => {
      startupDataSingleton = data;
      startupDataPromise = null;
      return data;
    })
    .catch((err) => {
      startupDataPromise = null;
      throw err;
    });
  return startupDataPromise;
}
